// src/components/Home.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => (
  <section
    id="home"
    className="relative bg-cover bg-center text-white w-full"
    style={{
      backgroundImage: "url('/assets/home/home.png')",
      height: '450px',
    }}
  >
    <div className="flex flex-col items-center justify-center h-full px-4 md:px-8 lg:px-12">
      <h2
        className="text-4xl md:text-5xl font-bold text-center mb-4"
        style={{
          color: '#FFFFFF',
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 100,
          lineHeight: '1.4em',
          textAlign: 'center',
          textTransform: 'none',
        }}
      >
        Structural design done right
      </h2>

      <p
        className="text-base md:text-lg lg:text-xl text-center mb-4"
        style={{
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 300,
        }}
      >
        Rubix designs elegant, efficient, and affordable structural systems in concrete, steel, and lumber.
      </p>

      <Link
        to="/work"
        className="bg-white hover:bg-orange-600 text-black font-bold py-2 px-4 rounded mt-4"
      >
        See our work
      </Link>
    </div>
  </section>
);

export default Home;